export default __webpack_public_path__ + "static/media/developer.81f6e7e7.gif";